import react from 'react';
import { LineItemOrderDetails } from '../../utils/kit/modules/paymentProcessing';
import { formatCurrencyValue } from '../../utils/currency';

interface LineItemReadOnlyDisplayProps {
    lineItem: LineItemOrderDetails
}

const LineItemReadOnlyDisplay = (props: LineItemReadOnlyDisplayProps) =>
{
     //TODO: Pull Currency from order
    const currency = {
        name: 'USD',
        localization: Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }),
        formatting: {
            prefix: '$',
            suffix: '',
            decimalSeparator: '.',
            groupSeparator: ',',
            decimalLimit: 2
        }
    }

    return(
            <div className='checkoutPageLineItemReadOnly'>
                <b>{props.lineItem.name}</b>
                <b className='checkoutPageUnitPriceDisplay'>Cost: {formatCurrencyValue(props.lineItem.price.totalPrice, currency.formatting).formatted}</b>
            </div>
    )
}

export default LineItemReadOnlyDisplay